__turbopack_context__.v({
  "buttonLink": "ButtonLink-module__WFqLvW__buttonLink" + " " + "cds-link",
});
